import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import React, { useEffect, useState } from 'react';

const blogData = [
  {
    id: 1,
    image: require('../assets/Not_Uni_01.jpg'),
    time: '16-Setembro-2023  | 09H - 12H',
    title: 'Actividade Solidária',
    description: 'Na Cerimônia de Outorga de Diplomas doInstituto Superior Politécnico Atlântida, os formandos da turma de 2024 se reuniram ansiosos no auditório.',
  },
  {
    id: 2,
    image: require('../assets/Not_Uni_02.jpg'),
    time: '24 e 25 DE MAIO 2024 | 07H',
    title: 'Estudantes de Análises Clínicas protagonistas da AHIA',
    description: 'Estudantes de Análises Clínicas do ISPA destacam-se na AHIA, apresentando projetos inovadores.',
  },
  {
    id: 3,
    image: require('../assets/Not_Uni_03.jpg'),
    time: '07-Setembro-2023  | 09H - 12H',
    title: 'Estudante do ISPA',
    description: 'Um estudante do ISPA compartilha sua experiência e aprendizado durante o curso, destacando a importância da educação na formação profissional.',
  },
  {
    id: 4,
    image: require('../assets/Not_Uni_04.jpg'),
    time: '07-Setembro-2023  | 09H - 12H',
    title: 'Actividade Solidária',
    description: 'A Actividade Solidária do ISPA visa promover a inclusão e o apoio à comunidade, através de diversas iniciativas e projetos sociais.',
  },
  {
    id: 5,
    image: require('../assets/Not_Uni_05.jpg'),
    time: '24 e 25 DE MAIO 2024 | 07H',
    title: '5ª Jornada Científica Geral',
    description: 'A 5ª Jornada Científica Geral do ISPA reunirá especialistas e estudantes para discutir inovações e pesquisas.',

  },
  {
    id: 6,
    image: require('../assets/Not_Uni_06.jpg'),
    time: '24 e 25 DE MAIO 2024  | 7H',
    title: 'Actividade Solidária',
    description: 'A Actividade Solidária do ISPA visa promover a inclusão e o apoio à comunidade, através de diversas iniciativas e projetos sociais.'
  },
  {
    id: 7,
    image: require('../assets/Not_Uni_07.jpg'),
    time: '07-Setembro-2023  | 09H - 12H',
    title: 'Actividade Solidária',
    description: 'Descubra o impacto que já causamos e inspire-se para se juntar à nossa causa! Veja como nossas atividades solidárias anteriores transformaram vidas e comunidades. Seja parte dessa história de mudança positiva. Clique para saber mais e se envolver"',
   
  },
  {
    id: 8,
    image: require('../assets/Not_Uni_08.jpg'),
    time: '07-Setembro-2023  | 09H - 12H',
    title: 'Actividade Solidária',
    description: 'Descubra o impacto que já causamos e inspire-se para se juntar à nossa causa! Veja como nossas atividades solidárias anteriores transformaram vidas e comunidades. Seja parte dessa história de mudança positiva. Clique para saber mais e se envolver',
  
  },
  {
    id: 9,
    image: require('../assets/Not_Uni_09.jpg'),
    time: '07-Setembro-2023  | 09H - 12H',
    title: 'Actividade Solidária',
    description: 'Descubra o impacto que já causamos e inspire-se para se juntar à nossa causa! Veja como nossas atividades solidárias anteriores transformaram vidas e comunidades. Seja parte dessa história de mudança positiva. Clique para saber mais e se envolver',
    
  }
]

function AppBlogOrganica() {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <section
      id="blog"
      className="block blog-block"
      style={{
        background: "#ffffff",
        padding: "40px 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh"
      }}
    >
      <Container fluid style={{ maxWidth: 1200 }}>
        <div className="title-holder" style={{ textAlign: "center", marginBottom: 40 }}>
          <h3 style={{ textAlign: 'center', fontWeight: 700, fontSize: "1.5rem", color: "#00731f" }}>
            Descubra Nossos Eventos Incríveis
          </h3>
          <div className="subtitle" style={{ margin: "10px 0", color: "#6c757d" }}>
            Inspire-se com as atividades que transformam vidas e impulsionam o conhecimento!
          </div>
        </div>
        <Row className="justify-content-center">
          {blogData.map(blog => (
            <Col sm={12} md={6} lg={4} key={blog.id} style={{ marginBottom: 30 }}>
              <div
                className={`holder slide-down-animation${animate ? ' animate' : ''}`}
                style={{
                  transition: "transform 0.4s cubic-bezier(.68,-0.55,.27,1.55), box-shadow 0.3s",
                  transform: animate ? "translateY(0)" : "translateY(40px)",
                  boxShadow: "0 4px 24px rgba(26,42,108,0.08)",
                  borderRadius: 16,
                  background: "#fff",
                  overflow: "hidden",
                  cursor: "pointer"
                }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 32px rgba(26,42,108,0.16)"}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "0 4px 24px rgba(26,42,108,0.08)"}
              >
                <Card style={{ border: "none", borderRadius: 16, overflow: "hidden" }}>
                  <div style={{ position: "relative" }}>
                    <Card.Img
                      variant="top"
                      src={blog.image}
                      style={{
                        height: 220,
                        objectFit: "cover",
                        filter: "brightness(0.95)",
                        transition: "filter 0.3s"
                      }}
                      onMouseOver={e => e.currentTarget.style.filter = "brightness(1)"}
                      onMouseOut={e => e.currentTarget.style.filter = "brightness(0.95)"}
                    />
                    <span style={{
                      position: "absolute",
                      top: 16,
                      left: 16,
                      background: "rgba(0, 115, 31, 0.85)",
                      color: "#fff",
                      padding: "6px 14px",
                      borderRadius: 12,
                      fontSize: 12,
                      fontWeight: 500,
                      letterSpacing: 1
                    }}>
                      {blog.time}
                    </span>
                  </div>
                  <Card.Body style={{ padding: "22px 18px 18px 18px" }}>
                    <Card.Title style={{ fontWeight: 700, fontSize: "1.2rem", color: "#00731f" }}>
                      {blog.title}
                    </Card.Title>
                    <Card.Text style={{ color: "#444", fontSize: 15, margin: "12px 0 0 0" }}>
                      {blog.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default AppBlogOrganica;